module.exports = __webpack_public_path__ + "static/media/subset-DINAlternate-Bold.38ab08d.03327a68.ttf";